import React from 'react';
import { VideoCard } from './VideoCard';
import { MediaGalleryProps } from '../../types/video';

export const VideoGallery: React.FC<MediaGalleryProps> = ({ items, onSelect, onDelete, onEdit, onRegenerate, previewLocked, onUpgrade }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((item) => (
                <VideoCard
                    key={item.id}
                    item={item}
                    onClick={() => onSelect(item)}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onRegenerate={onRegenerate}
                    previewLocked={previewLocked}
                    onUpgrade={onUpgrade}
                />
            ))}
        </div>
    );
};
